import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowRight, Check } from 'lucide-react';
import { mockIndustries } from '../mock';
import './IndustryDetail.css';

const IndustryDetail = () => {
  const { industryId } = useParams();
  const industry = mockIndustries.find(ind => ind.id === industryId);

  if (!industry) {
    return (
      <div className="industry-detail-page">
        <div style={{ textAlign: 'center', padding: '200px 20px' }}>
          <h1 className="display-large">Industry Not Found</h1>
          <Link to="/industries" className="btn-primary" style={{ marginTop: '40px' }}>
            Back to Industries
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="industry-detail-page">
      {/* Hero */}
      <section className="industry-hero" style={{ backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url(${industry.image})` }}>
        <div className="industry-hero-content">
          <h1 className="display-huge">{industry.name}</h1>
          <p className="body-large" style={{ marginTop: '24px', color: 'var(--brand-primary)', fontWeight: '500' }}>
            {industry.tagline}
          </p>
          <p className="body-large" style={{ marginTop: '24px' }}>
            {industry.description}
          </p>
          <div style={{ marginTop: '40px' }}>
            <Link to="/demo" className="btn-primary">
              Request Demo <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>

      {/* Features */}
      <section className="industry-section">
        <h2 className="display-large" style={{ textAlign: 'center' }}>Key Features</h2>
        <div className="features-grid">
          {industry.features.map((feature, idx) => (
            <div key={idx} className="feature-card">
              <Check size={32} color="var(--brand-primary)" />
              <h3 className="heading-2" style={{ marginTop: '20px' }}>{feature}</h3>
            </div>
          ))}
        </div>
      </section>

      {/* Use Cases */}
      <section className="industry-section">
        <h2 className="display-large" style={{ textAlign: 'center' }}>Common Use Cases</h2>
        <div className="use-cases-list">
          {industry.useCases.map((useCase, idx) => (
            <div key={idx} className="use-case-item">
              <div className="use-case-number">{String(idx + 1).padStart(2, '0')}</div>
              <p className="body-large">{useCase}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="industry-cta">
        <h2 className="display-large">Ready to Get Started?</h2>
        <p className="body-large" style={{ marginTop: '24px' }}>
          See how EAET can transform your {industry.name.toLowerCase()} operations.
        </p>
        <div style={{ marginTop: '40px', display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
          <Link to="/demo" className="btn-primary">
            Book a Demo <ArrowRight size={20} />
          </Link>
          <Link to="/industries" className="btn-secondary">
            View Other Industries
          </Link>
        </div>
      </section>
    </div>
  );
};

export default IndustryDetail;